import Axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { RpcEvent } from '@/events';

interface ErrorResponse {
    result: string,
    msg?: string,
}

function handleError(error: ErrorResponse) {
    if(error.msg) throw new Error(error.msg);
    else throw new Error('Got Error Response');
}

export async function getAsync(url: string, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
        response = await Axios.get(url, options);
        if(response.data.result === 'error') handleError(response.data);
    }
    catch(err) {
        RpcEvent.emit('error', err);
        throw err;
    }
    return response;
}

export async function postAsync(url: string, value: any, options?: AxiosRequestConfig): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
        response = await Axios.post(url, value, options);
        if(response.data.result === 'error') handleError(response.data);
    }
    catch(err) {
        RpcEvent.emit('error', err);
        throw err;
    }
    return response;
}

export async function patchAsync(url: string, value: any): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
        response = await Axios.patch(url, value);
        if(response.data.result === 'error') handleError(response.data);
    }
    catch(err) {
        RpcEvent.emit('error', err);
        throw err;
    }
    return response;
}

export async function deleteAsync(url: string): Promise<AxiosResponse> {
    let response: AxiosResponse;
    try {
        response = await Axios.delete(url);
        if(response.data.result === 'error') handleError(response.data);
    }
    catch(err) {
        RpcEvent.emit('error', err);
        throw err;
    }
    return response;
}
